export const ROUTE_PATH = {
  ASSESSMENT_LIST: '/',
  ASSESSMENT_CREATE: '/assessment/create',
  ASSESSMENT_EDIT: '/assessment/:id'
} as const
